




import Vue, { PropType } from 'vue';

import { DynamicDocumentItem } from '@/types';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
  },
});
